module.exports = __webpack_public_path__ + "static/media/8_9_CAM.a3623567.png";